import React, { useMemo } from "react";

export const ReminderMessage = ({msg}) => {
    
    return (
        <div className={`rounded-md bg-yellow-100 shadow`}>
            <div className={`text-gray-800 text-center`}>
                <h1 className={`p-1 rounded-t-md font-light text-sm`}>{msg.message?.text}</h1>
            </div>
        </div>
    );
};